import TestVor from "../img/vorspeisen.jpg"
import TestHaupt from "../img/hauptgerichte.jpg"
import TestTrink from "../img/drink.jpg"

export default function() {
    return {
        "haupt" :[
            {img: TestVor, title: "Pho Bo", description:"Reisbandnudelsuppe mit Rindersteakstreifen • geschmortem Rinderfleisch • Ingwer • roten Zwiebeln • Frühlingslauch • frischen Kräuter", price:"Preis"},
            {img: TestVor, title: "Pho Ga", description:"Reisbandnudelsupper mit Maishähnchen aus der Rotsserie • Frühlingslauch • roten Zwiebeln • Limettenblätter • frischen Kräuter", price:"Preis"},
            {img: TestVor, title: "Bun Bo Hue", description:"Reisnudelsuppe mit geschmortem Rindfleisch • Schweinefleisch • Zitronengrass • Frühlingszwiebel • frischen Kräuter", price:"Preis"},
            {img: TestVor, title: "Bun Ga Mang Moc", description:"Reisnudelsuppe mit Meishähnchen • Fleischbällchen • Bambusstreifen • Frühlingslauch • frischen Kräuter", price:"Preis"},
            {img: TestVor, title: "Bunb Bo Hue", description:"Reisnudelsuppe mit geschmortem Rindfleisch • Schweinefleisch • Zitronengrass • Frühlingszwiebel • frischen Kräuter", price:"Preis"},
        ],
        "vor": [
            {img: TestHaupt, title: "Cha Gio", description:"Hausgemachte frittierte Frühlingsrollen • Schweinefleisch • Glasnudel • Mu Err Pilze • Karotten • VietPho Dip", price:"Preis"},
            {img: TestHaupt, title: "Goi Cuon Tom Thit", description:"Sommerrollen gefüllt mit Reisnudel • mariniertem Schweinefleisch • Garnelen", price:"Preis"},
            {img: TestHaupt, title: "Banh Xeo", description:"Knuspriger Pfannkuchen nach traditionell vietnamesicher Art gefüllt mit Garnele • Sojasproßen • Salat", price:"Preis"},
            {img: TestHaupt, title: "Goi Du Du", description:"Grüner Papaya Salat mit Karotten • Rettich • frischen Kräutern • gerösteten Erdnüssen • pikant gewürzt mit VietPho Dressing", price:"Preis"},

    
        ],
        "cock": [
            {img: TestTrink, title: "Mai Tai 1944", description:"White Rum • Brewer Rum Overproof • Curacao Orange • Limettensaft • Falemum", price:"Preis"},
            {img: TestTrink, title: "Tequilla Sunrise", description:"Tequila silver • Orangensaft Granatapfelsirrup", price:"Preis"},
            {img: TestTrink, title: "Mojito 1931", description:"Rum • Minze • Limettensaft • Zucker • Soda • Bitters", price:"Preis"},
            {img: TestTrink, title: "Long Island Ice Tea", description:"Wodka • Tequila • Rum • Gin • Cointreau • Cola • Orangensaft", price:"Preis"},
            {img: TestTrink, title: "Singapore Sling 1930", description:"Gin • Cherry Brandy • Zitronensaft • Zuckersirup • Soda • Angostura Bitter", price:"Preis"},
        ]    
    }
}



// WEBPACK FOOTER //
// ./src/data/menu-items.js